import { AppRouteProps } from "@bsm/component";
import { StudentSchoolAttendedContainer } from "./container/StudentSchoolAttendedContainer";

export const SchoolAttendedRoutes: Array<AppRouteProps> = [
    {
        path: "schoolAttended",
        element: <StudentSchoolAttendedContainer />,
    },
];